<template>
  <div class="home">
    <HeaderPage />

    <el-card v-if="$can('1|2|6')" shadow="never" :body-style="{ padding: '0px' }" style="background-color: transparent; border: none; max-width: 2500px; min-height: auto">
      <div class="dasbhboard-geral">
        <el-card
            v-loading="loadingPage"
            :body-style="{ padding: '10px' }"
            style="margin: 0px auto 0px; min-height: auto; max-width: 100%"
        >
          <el-row :gutter="10" style="display: flex; justify-content: center;">
            <el-col :lg="8" :sm="24" :xs="24" class="graph-card">
              <VendasNoDia />
            </el-col>
            <el-col :lg="8" :sm="24" :xs="24" class="graph-card">
              <VendasTotal />
            </el-col>
            <el-col :lg="8" :sm="24" :xs="24" class="graph-card">
              <QtdTransacoesAprovadas />
            </el-col>
          </el-row>
          <el-row :gutter="10" style="display: flex; justify-content: center;">
            <el-col :lg="12" :sm="24" :xs="24" class="graph-card">
              <VendasNoMes />
            </el-col>
            <el-col :lg="12" :sm="24" :xs="24" class="graph-card">
              <TPVComparado />
            </el-col>
          </el-row>
          <el-row :gutter="10" style="display: flex; justify-content: center;">
            <el-col :lg="8" :sm="24" :xs="24" class="graph-card">
              <AjustesNoMes />
            </el-col>
            <el-col :lg="8" :sm="24" :xs="24" class="graph-card">
              <AjustesPendentes />
            </el-col>
            <el-col :lg="8" :sm="24" :xs="24" class="graph-card">
              <ChargeBackNoMes />
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :lg="12" :sm="24" :xs="24" class="graph-card">
              <CredenciamentoPendente />
            </el-col>
            <el-col :lg="12" :sm="24" :xs="24" class="graph-card">
              <CredenciamentoNoMes />
            </el-col>
            <el-col :lg="12" :sm="24" :xs="24" class="graph-card">
              <ClientesAptosTransacionar />
            </el-col>
            <el-col :lg="12" :sm="24" :xs="24" class="graph-card">
              <ClientesAtivosMes />
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "../../../components/HeaderPage.vue";
import {mapGetters} from "vuex";
import VendasNoDia from "./graphs/individualCards/VendasNoDia.vue";
import VendasTotal from "./graphs/individualCards/VendasTotal.vue";
import QtdTransacoesAprovadas from "./graphs/individualCards/QtdTransacoesAprovadas.vue";
import VendasNoMes from "./graphs/individualCards/VendasNoMes.vue";
import TPVComparado from "./graphs/individualCards/TPVComparado.vue";
import AjustesNoMes from "./graphs/individualCards/AjustesNoMes.vue";
import AjustesPendentes from "./graphs/individualCards/AjustesPendentes.vue";
import ChargeBackNoMes from "./graphs/individualCards/ChargeBackNoMes.vue";
import CredenciamentoPendente from "./graphs/individualCards/CredenciamentoPendente.vue";
import CredenciamentoNoMes from "./graphs/individualCards/CredenciamentoNoMes.vue";
import ClientesAtivosMes from "./graphs/individualCards/ClientesAtivosMes.vue";
import ClientesAptosTransacionar from "./graphs/individualCards/ClientesAptosTransacionar.vue";

export default {
  name: "HomeHomeMktAdmin",

  components: {
    ClientesAptosTransacionar,
    ClientesAtivosMes,
    CredenciamentoNoMes,
    CredenciamentoPendente,
    ChargeBackNoMes,
    AjustesPendentes,
    AjustesNoMes,
    TPVComparado,
    VendasNoMes,
    QtdTransacoesAprovadas,
    VendasTotal,
    VendasNoDia,
    HeaderPage,
  },

  computed: {
    ...mapGetters("Auth", ["currentUser", "getColorTheme"])
  },

  data() {
    return {
      loadingPage: false,
    }
  },
}

</script>

<style scoped>

</style>